import React from "react";
import styled from "@emotion/styled";

type ImageCardProps = {
	bgImage: string;
	icon: string;
	title: string;
	description?: string;
	extra: any;
};

export const ImageCard = ({
	bgImage,
	icon,
	title,
	description,
	extra,
}: ImageCardProps) => {
	const Card = styled("div")`
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		transition: transform 0.2s ease-in-out;
		&:before {
			content: "";
			display: block;
			position: absolute;
			z-index: -10;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			opacity: 1;
			background-image: url("${bgImage}");
			background-repeat: no-repeat;
			background-position: 50% 0;
			background-size: cover;
			border-radius: 8px;
		}
		&:hover {
			transform: translateY(-5px);
		}
		h3 {
			margin-bottom: 0px;
		}
		p {
			padding: 0px 20px;
			font-style: italic;
			text-align: center;
			margin-bottom: 45px;
			margin-top: 5px;
		}
		> img {
			height: 160px;
		}
	`;
	return (
		<Card>
			<img src={icon} alt={`${title} icon`} />
			<h3>{title}</h3>
			<p>{description}</p>
			{extra}
		</Card>
	);
};
